export const TBL_HEADERS = [
  {
    name: "Actions",
    variable: "",
  },
  {
    name: "QC Name",
    variable: "testName",
  },
  {
    name: "QC Level",
    variable: "testType",
  },
];
